import FloorPlanDetail from '../components/FloorPlanDetail';

export default function FloorPlan21Page() {
  const floorPlanData = {
    id: '2-1',
    title: '2+1 Örnek Daire',
    totalArea: '95 m²',
    rooms: '2 Yatak Odası + 1 Salon',
    image: '/plan-2-1.png',
    description: '2+1 daire tipimiz, modern yaşam alanları arayanlar için ideal bir seçenektir. Geniş salon alanı, fonksiyonel mutfak ve konforlu yatak odaları ile ailenizin tüm ihtiyaçlarını karşılayacak şekilde tasarlanmıştır. Açık mutfak konsepti sayesinde daha geniş bir yaşam alanı elde ederken, geniş balkon ile doğal ışık ve hava sirkülasyonundan maksimum düzeyde faydalanabilirsiniz.',
    roomDetails: [
      { name: 'Salon', dimensions: '4.20 x 5.80 m', area: '24.36 m²' },
      { name: 'Mutfak', dimensions: '2.80 x 3.50 m', area: '9.80 m²' },
      { name: 'Ana Yatak Odası', dimensions: '3.40 x 4.20 m', area: '14.28 m²' },
      { name: 'Yatak Odası', dimensions: '3.00 x 3.80 m', area: '11.40 m²' },
      { name: 'Banyo', dimensions: '2.20 x 2.80 m', area: '6.16 m²' },
      { name: 'Ebeveyn Banyosu', dimensions: '1.80 x 2.40 m', area: '4.32 m²' },
      { name: 'Balkon', dimensions: '1.40 x 8.50 m', area: '11.90 m²' },
      { name: 'Koridor & Hol', dimensions: '-', area: '12.78 m²' }
    ],
    features: [
      'Geniş ve ferah salon alanı',
      'Açık mutfak konsepti',
      'Ana yatak odasına özel banyo',
      'Geniş balkon alanı',
      'Doğal ışık alan tasarım',
      'Fonksiyonel oda düzeni',
      'Giyinme dolabı alanları',
      'Merkezi ısıtma sistemi',
      'Yerden ısıtma',
      'Akıllı ev altyapısı'
    ]
  };

  return <FloorPlanDetail data={floorPlanData} />;
}